import React, { useState, useEffect } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import { ReactSortable } from 'react-sortablejs'
import { notRepeatingShuffleForRank } from '../utils/SmartLabelUtils'
import MenuIcon from '@material-ui/icons/Menu'
import 'katex/dist/katex.min.css'
import { SlideQuestion } from '../UIUtilsFiles/SlideQuestion'
import { DragVertical } from '@carbon/icons-react'

function RankList(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    screenMode,
    handleSuccessChange,
    timerEnd
  } = props
  const {
    ControlID,
    QuestionText,
    QuestionType,
    Answers,
    Score,
    AnswerColorFill,
    Background,
    Description,
    QuestionColorFill,
    AnswerFontSize,
    QuestionFontSize,
    Opacity,
    AnswerFillColor,
    QuestionFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    FontStyle,
    Italic,
    Bold
  } = mcData

  const [sortedRankValueArray, setSortedRankValueArray] = useState([])
  const [sentence, setSentence] = useState([])
  const [initial, setInitial] = useState(true)
  const [selectedOption, setSelectedOption] = useState('')

  useEffect(() => {
    let sentenceCopy = []
    for (let i = 0; i < Answers.length; i++) {
      sentenceCopy.push(Answers[i])
    }
    setSentence(sentenceCopy)
    if (defaultValue) {
      let defaultValueSelected = defaultValue.CtlValue
      setSortedRankValueArray(defaultValueSelected)
      setInitial(false)
    } else {
      setSortedRankValueArray(notRepeatingShuffleForRank(Answers))
    }
  }, [defaultValue])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick) {
      let sortedRankValueArrayCopy = []
      let sentenceArrayCopy = []
      for (let index = 0; index < sortedRankValueArray.length; index++) {
        sortedRankValueArrayCopy.push({
          Option: sortedRankValueArray[index].Option
        })
      }
      for (let index = 0; index < sentence.length; index++) {
        sentenceArrayCopy.push({
          Option: sentence[index].Option
        })
      }
      if (
        JSON.stringify(sentenceArrayCopy) ===
        JSON.stringify(sortedRankValueArrayCopy)
      ) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    }
  }, [explanationClick])

  function handleOptionChange() {
    onAttemptChange(1)
    if (selectedOption && selectedOption !== '') {
      const selectedIndex = sortedRankValueArray.findIndex(
        (answer) => answer.Option === selectedOption
      )
      const correctAnswerIndex = Answers.findIndex(
        (answer) => answer.Option === selectedOption
      )
      if (selectedIndex === correctAnswerIndex) {
        handleSuccessChange(true)
      } else {
        handleSuccessChange(false)
      }
      setSelectedOption('')
    }
    validateCorrectAnswer()
  }

  function validateCorrectAnswer(timerValue) {
    let sortedRankValueArrayCopy = []
    let sentenceArrayCopy = []
    for (let index = 0; index < sortedRankValueArray.length; index++) {
      sortedRankValueArrayCopy.push({
        Option: sortedRankValueArray[index].Option
      })
    }
    for (let index = 0; index < sentence.length; index++) {
      sentenceArrayCopy.push({
        Option: sentence[index].Option
      })
    }
    if (
      JSON.stringify(sentenceArrayCopy) ===
      JSON.stringify(sortedRankValueArrayCopy)
    ) {
      onValueChange(
        ControlID,
        sortedRankValueArray,
        Score,
        Score,
        '',
        timerValue
      )
    } else {
      onValueChange(ControlID, sortedRankValueArray, 0, Score, '', timerValue)
    }
  }

  return (
    <div className='slide-comp-wrapper'>
      {!isVerifyMode ? (
        <ReactSortable
          className='rank-sort-cont'
          list={sortedRankValueArray}
          setList={(sortList) => {
            if (sortList.length > 0) {
              setInitial(false)
            } else {
              setInitial(true)
            }
            setSortedRankValueArray(sortList)
          }}
          swap={true}
          onEnd={() => handleOptionChange()}
        >
          {sortedRankValueArray.map((item, index) => (
            <div
              key={index.toString()}
              id={index}
              className={
                initial || (selectedOption && selectedOption === item.Option)
                  ? 'rank-item-cont default-border'
                  : isPractice || completed === 1 || !isActive
                  ? Answers[index].Option === item.Option
                    ? 'rank-item-cont right-border'
                    : 'rank-item-cont wrong-border'
                  : 'rank-item-cont default-border'
              }
              style={{
                width: screenMode === 'phone' ? '100%' : '70%',
                backgroundColor:
                  selectedOption && selectedOption === item.Option
                    ? '#ffc42d'
                    : AnswerFillColor
              }}
              onMouseDown={() => {
                setSelectedOption(item.Option)
              }}
            >
              <DragVertical
                className='rank-drag-icon'
                color={
                  selectedOption && selectedOption === item.Option
                    ? '#000000'
                    : AnswerColorFill
                }
              />
              <p
                className='rank-item-label'
                style={{
                  color:
                    selectedOption && selectedOption === item.Option
                      ? '#000000'
                      : AnswerColorFill,
                  fontSize:
                    AnswerFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : AnswerFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  fontFamily: FontStyle,
                  fontStyle: Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: Bold === 'True' ? 'bold' : 'normal'
                }}
              >
                {item.Option}
              </p>
            </div>
          ))}
        </ReactSortable>
      ) : (
        <ReactSortable
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
          list={Answers}
          setList={(sortList) => {
            if (sortList.length > 0) {
              setInitial(false)
            } else {
              setInitial(true)
            }
            setSortedRankValueArray(sortList)
          }}
          swap={true}
        >
          {Answers.map((item, index) => (
            <div
              key={index.toString()}
              style={{
                width: screenMode === 'phone' ? '100%' : '70%',
                display: 'flex',
                backgroundColor: AnswerFillColor,
                justifyContent: 'center',
                borderRadius: '10px',
                marginTop: '2%',
                borderWidth: '2px',
                borderColor: '#0bff31',
                cursor: 'pointer',
                borderStyle: 'solid',
                alignSelf: 'center',
                alignItems: 'center',
                padding: '2%'
              }}
            >
              <MenuIcon
                style={{
                  width: '30px',
                  height: '30px',
                  color: AnswerColorFill,
                  cursor: 'pointer'
                }}
              />
              <p
                style={{
                  width: '100%',
                  color: AnswerColorFill,
                  fontSize:
                    AnswerFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : AnswerFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  display: 'flex',
                  justifyContent: 'center',
                  textAlign: 'justify',
                  margin: 'auto',
                  fontFamily: FontStyle,
                  fontStyle: Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: Bold === 'True' ? 'bold' : 'normal'
                }}
              >
                {item.Option}
              </p>
            </div>
          ))}
        </ReactSortable>
      )}
    </div>
  )
}

export default RankList
